import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  getTiposCaracteristicas,
  getTiposEquiposRadiologicos,
  getTiposFuentes,
  getTiposMetodosProcesamiento,
  getTiposRadiacion,
} from "../../../../../../../../../redux/actions/resolucion";
import FormikActions from "../../../../../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../../../../../commons/formik/FormikAutocomplete";
import FormikCheckbox from "../../../../../../../../commons/formik/FormikCheckbox";
import FormikTextField from "../../../../../../../../commons/formik/FormikTextField";
import CharactersCounterLabel from "../../../../../../../../commons/labels/CharactersCounterLabel";
import { StyledResolucion } from "../../../../../../../../styled/Prevencion";
import { validateNewEquipoRadiologico } from "../../../../formValidations";

const EquipoRadiologicoForm = ({ open, handleClose, handleSubmit, values }) => {
    const dispatch = useDispatch();
    const tiposEquiposRadiologicos = useSelector(
        (state) => state.resolucion.tiposEquiposRadiologicos
    );
    const tiposCaracteristicas = useSelector(
        (state) => state.resolucion.tiposCaracteristicas
    );
    const tiposRadiacion = useSelector(
        (state) => state.resolucion.tiposRadiacion
    );
    const tiposFuentes = useSelector((state) => state.resolucion.tiposFuentes);
    const metodosDeProcesamiento = useSelector(
        (state) => state.resolucion.tiposMetodosProcesamiento
    );

    return (
        <Dialog open={open} fullWidth maxWidth="lg">
            <DialogTitle>Nuevo Equipo Radiológico</DialogTitle>
            <Formik
                initialValues={values}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={validateNewEquipoRadiologico}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        <DialogContent>
                            <Grid container >
                                <StyledResolucion.DialogGridItem item container xs={12} >
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikTextField name="marca" label="Marca *" fullWidth />
                                    </StyledResolucion.DialogGridItem>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikTextField name="modelo" label="Modelo *" fullWidth />
                                    </StyledResolucion.DialogGridItem>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikAutocomplete
                                            name="idTipoEquipoRadiologico"
                                            label="Tipo *"
                                            options={tiposEquiposRadiologicos.data}
                                            renderOption={(option) => option.nombre}
                                            fullWidth
                                            getOptions={() => dispatch(getTiposEquiposRadiologicos())}
                                        />
                                    </StyledResolucion.DialogGridItem>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikAutocomplete
                                            name="idCaracteristicaEquipoRadiologico"
                                            label="Característica *"
                                            options={tiposCaracteristicas.data}
                                            renderOption={(option) => option.nombre}
                                            fullWidth
                                            getOptions={() => dispatch(getTiposCaracteristicas())}
                                        />
                                    </StyledResolucion.DialogGridItem>
                                </StyledResolucion.DialogGridItem>

                                <StyledResolucion.DialogGridItem item container xs={12}>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikAutocomplete
                                            name="idTipoRadiacion"
                                            label="Tipo de Radiación *"
                                            options={tiposRadiacion.data}
                                            renderOption={(option) => option.nombre}
                                            fullWidth
                                            getOptions={() => dispatch(getTiposRadiacion())}
                                        />
                                    </StyledResolucion.DialogGridItem>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikTextField
                                            name="actividad"
                                            label="Actividad *"
                                            fullWidth
                                        />
                                    </StyledResolucion.DialogGridItem>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikTextField
                                            name="radioisotipoFuente"
                                            label="Radioisotipo Fuente *"
                                            fullWidth
                                        />
                                    </StyledResolucion.DialogGridItem>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikAutocomplete
                                            name="idTipoFuente"
                                            label="Tipo de Fuente *"
                                            options={tiposFuentes.data}
                                            renderOption={(option) => option.nombre}
                                            getOptions={() => dispatch(getTiposFuentes())}
                                        />
                                    </StyledResolucion.DialogGridItem>
                                </StyledResolucion.DialogGridItem>

                                <StyledResolucion.DialogGridItem item container xs={12} >
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikTextField
                                            name="potenciaEquipoKVP"
                                            label="Potencia KVP *"
                                            fullWidth
                                        />
                                    </StyledResolucion.DialogGridItem>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikTextField
                                            name="potenciaEquipomAp"
                                            label="Potencia mAp *"
                                            fullWidth
                                        />
                                    </StyledResolucion.DialogGridItem>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikTextField
                                            name="potenciaEquipoMeV"
                                            label="Potencia MeV *"
                                            fullWidth
                                        />
                                    </StyledResolucion.DialogGridItem>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikCheckbox
                                            name="procesamientoImagenes"
                                            label="Procesamiento de Imágenes"
                                            callBack={(value) => {
                                                if (!value) {
                                                    setFieldValue("idTipoMetodoProcesamientoImagen", "");
                                                }
                                            }}
                                        />
                                    </StyledResolucion.DialogGridItem>
                                    <StyledResolucion.DialogGridItem item xs={3}>
                                        <FormikAutocomplete
                                            name="idTipoMetodoProcesamientoImagen"
                                            label="Método de Procesamiento *"
                                            options={metodosDeProcesamiento.data}
                                            renderOption={(option) => option.nombre}
                                            getOptions={() => dispatch(getTiposMetodosProcesamiento())}
                                            disabled={!values.procesamientoImagenes}
                                        />
                                    </StyledResolucion.DialogGridItem>
                                </StyledResolucion.DialogGridItem>

                                <StyledResolucion.DialogGridItem
                                    item
                                    container
                                    xs={12}
                                    justifyContent="flex-end"
                                    spacing={1}
                                >
                                    <StyledResolucion.DialogGridItem item xs={12}>
                                        <FormikTextField
                                            name="observaciones"
                                            label="Observaciones *"
                                            multiline
                                            variant="outlined"
                                            fullWidth
                                            maxRows={4}
                                        />
                                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                                            Para aquellos equipos que por su especificidad requieran mayores datos para su caracterización, deberán indicarse en este campo.
                                        </Typography>
                                    </StyledResolucion.DialogGridItem>
                                    {values.observaciones > 0 && <StyledResolucion.DialogGridItem item xs={2}>
                                        <CharactersCounterLabel
                                            value={values.observaciones}
                                            maxCharacters={200}
                                        />
                                    </StyledResolucion.DialogGridItem>}
                                </StyledResolucion.DialogGridItem>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <FormikActions handleCancel={handleClose} />
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default EquipoRadiologicoForm;
